export default __webpack_public_path__ + "static/media/Introduction.14c96f97.png";